var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13.001,
    viewBox: "0 0 13 13.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M6.5,6A6.932,6.932,0,0,1,2.525,4.757,6.994,6.994,0,0,1,0,1.568,6.994,6.994,0,0,1,2.525-1.62a6.975,6.975,0,0,1,7.949,0A6.994,6.994,0,0,1,13,1.568a6.994,6.994,0,0,1-2.525,3.189A6.932,6.932,0,0,1,6.5,6Zm0-7.387A2.955,2.955,0,1,0,9.455,1.568,2.958,2.958,0,0,0,6.5-1.386Zm0,4.727A1.773,1.773,0,1,1,8.273,1.568,1.775,1.775,0,0,1,6.5,3.341Zm3.964-6h0l-.418-.418.932-1.476,1.432-.887.418.417L10.464-2.655Zm-7.509,0h0L1.8-3.813.591-5.019l.418-.417L2.514-4.5l.858,1.427-.417.418Zm4.136-.8H6.5L6.2-5.1,6.5-7h.591l.333,1.9L7.091-3.455Z",
    transform: "translate(0 7)",
    fill: "#7a7a7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.a9f5b554.svg";
export { ForwardRef as ReactComponent };